import analytics from '@utils/analytics';
import anime from 'animejs';
import Hammer from 'hammerjs';
import BaseComponent from '../base/baseComponent';
let debouncerId;
export default class GeniusDesignersComponent extends BaseComponent {
    constructor(element) {
        super(element);
        this.animations = [];
        this.dragControl = document.querySelector('.genius-designer__controls--bottom');
        this.movePx = 100;
        this.generalManagers = [];
        this.isDragging = false;
        this.stoppedFromButton = false;
        window.addEventListener('load', () => {
            this.checkWidth();
            this.initComponent(true);
        });
        window.addEventListener('resize', () => {
            clearTimeout(debouncerId);
            debouncerId = window.setTimeout(() => {
                this.destroyAll();
                setTimeout(() => this.initComponent(), 400);
            }, 300);
        });
    }
    checkWidth() {
        this.maximumWidth = document.querySelector('.designers-row__inner-row').scrollWidth;
    }
    destroyAll() {
        this.maximumWidth = 0;
        clearTimeout(this.timerId);
        anime.remove('.genius-designers__designers-row');
        this.generalManagers.forEach(({ manager, generalHandlePan, Drag }) => {
            manager.remove(Drag);
            manager.off('pan', generalHandlePan);
            manager.destroy();
        });
        this.animations = [];
        this.generalManagers = [];
        this.checkWidth();
    }
    playComponent(changeButtonStatus = true) {
        this.animations.forEach((animation) => {
            animation.play();
        });
        if (changeButtonStatus) {
            this.$el.querySelectorAll('[data-pause]').forEach((btn) => {
                btn.setAttribute('aria-pressed', 'false');
            });
        }
    }
    pauseComponent(changeButtonStatus = true) {
        this.animations.forEach((animation) => {
            animation.pause();
        });
        if (changeButtonStatus) {
            this.$el.querySelectorAll('[data-pause]').forEach((btn) => {
                btn.setAttribute('aria-pressed', 'true');
            });
        }
    }
    initComponent(firstTime) {
        if (firstTime) {
            this.$el.querySelector('.designers-row--wrapper').addEventListener('mouseenter', (e) => {
                if (this.stoppedFromButton)
                    return;
                this.pauseComponent(false);
            });
            this.$el.querySelector('.designers-row--wrapper').addEventListener('mouseleave', (e) => {
                if (this.stoppedFromButton)
                    return;
                this.playComponent(false);
            });
            this.$el.querySelectorAll('.single-designer__name').forEach((link) => {
                link.addEventListener('click', (e) => {
                    if (this.isDragging) {
                        e.preventDefault();
                    }
                    else {
                        analytics.designerClick(link.querySelector('.single-designer__designer-name').innerHTML);
                    }
                });
            });
            this.$el.querySelectorAll('[data-pause]').forEach((link) => {
                link.addEventListener('click', (e) => {
                    const isPlaying = e.target.getAttribute('aria-pressed') === 'false' ? true : false;
                    if (isPlaying) {
                        this.pauseComponent();
                        this.stoppedFromButton = true;
                    }
                    else {
                        this.playComponent();
                        this.stoppedFromButton = false;
                    }
                });
            });
            this.$el.querySelectorAll('[data-backward]').forEach((link) => {
                link.addEventListener('click', () => {
                    this.animations.forEach((animation, index) => {
                        let newMove = animation.currentTime;
                        newMove += this.movePx * 3;
                        animation.pause();
                        animation.seek(newMove);
                    });
                });
            });
            this.$el.querySelectorAll('[data-forward]').forEach((link) => {
                link.addEventListener('click', () => {
                    this.animations.forEach((animation, index) => {
                        let newMove = animation.currentTime;
                        newMove -= this.movePx * 3;
                        animation.pause();
                        animation.seek(newMove);
                    });
                });
            });
        }
        this.$el.querySelectorAll('.genius-designers__designers-row').forEach((row, index) => {
            const singleRow = row;
            const oddRow = Boolean(index % 2);
            const jumpPx = this.maximumWidth - this.maximumWidth / (index + 1);
            singleRow.querySelectorAll('.designers-row__inner-row').forEach((innerRow, index) => {
                const wrapper = innerRow;
                switch (index) {
                    case 0:
                        wrapper.style.left = `-${this.maximumWidth + jumpPx}px`;
                        break;
                    case 1:
                        wrapper.style.left = `-${jumpPx}px`;
                        break;
                    case 2:
                        wrapper.style.left = `${this.maximumWidth - jumpPx}px`;
                        break;
                }
            });
            const alpha = oddRow ? 1 : -1;
            const move = this.maximumWidth * alpha;
            this.animations.push(anime({
                targets: singleRow,
                translateX: move,
                translateZ: 0,
                duration: this.maximumWidth * 15,
                loop: true,
                easing: 'linear',
            }));
            this.initPanManager(singleRow, oddRow);
        });
        this.initPanManager(this.dragControl, undefined, true);
    }
    initPanManager(el, oddRow, isDragBtn) {
        const manager = new Hammer(el);
        const Drag = new Hammer.Pan({
            direction: Hammer.DIRECTION_HORIZONTAL,
            threshold: 10,
        });
        manager.add(Drag);
        const generalHandlePan = (ev) => {
            this.handlePan(ev, oddRow, isDragBtn);
        };
        manager.on('pan', generalHandlePan);
        this.generalManagers.push({ manager, generalHandlePan, Drag });
    }
    handlePan(ev, oddRow, isDragBtn) {
        if (!this.isDragging) {
            this.isDragging = true;
            if (isDragBtn) {
                analytics.dragToExplore();
            }
        }
        clearTimeout(this.timerId);
        this.$el.classList.add('dragging');
        this.animations.forEach((animation) => {
            let newMove = animation.currentTime;
            if (ev.direction === 2) {
                if (oddRow) {
                    newMove -= this.movePx;
                }
                else {
                    newMove += this.movePx;
                }
            }
            if (ev.direction === 4) {
                if (oddRow) {
                    newMove += this.movePx;
                }
                else {
                    newMove -= this.movePx;
                }
            }
            if (ev.direction === 2 || ev.direction === 4) {
                animation.pause();
                animation.seek(newMove);
            }
        });
        if (ev.isFinal) {
            this.timerId = window.setTimeout(() => {
                this.isDragging = false;
                this.$el.classList.remove('dragging');
                if (window.isMobile) {
                    this.playComponent();
                }
            }, 500);
        }
    }
}
